<template>
    <div class="vote" v-loading='proloading'>
        <div class="add_tits" ref="titles">
            <el-form class="form-inlines u-f u-jsb" :inline="true">
                <div></div>
                <div>
                    <el-form-item>
                        <el-button type="primary" icon="el-icon-circle-plus-outline" size="small" @click="handleAdd">
                            新增
                        </el-button>
                    </el-form-item>
                </div>
            </el-form>
        </div>
        <el-table :data="proData" border v-loading="loading" :height="height" class="tableLimit votebox">
            <el-table-column  type="index" label="序号" width="80"></el-table-column>
            <el-table-column prop="start_time" label="开始日期" show-overflow-tooltip></el-table-column>
            <el-table-column prop="end_time" label="结束日期" show-overflow-tooltip></el-table-column>
            <el-table-column prop="count" label="总数" show-overflow-tooltip></el-table-column>
            <el-table-column prop="price" label="金额" show-overflow-tooltip></el-table-column>
            <el-table-column prop="point" label="积分" show-overflow-tooltip></el-table-column>
            <el-table-column prop="sale" label="已兑换" show-overflow-tooltip></el-table-column>
            
            <el-table-column label="操作" width="200" align="center">
                <template slot-scope="scope">
                    <el-button size="mini" type="primary" icon="el-icon-edit-outline"
                        @click="handleEdit(scope.row,scope.$index)"></el-button>
                    <el-button size="mini" type="danger" icon="el-icon-delete"
                        @click="handleDelet(scope.row,scope.$index)"></el-button>
                </template>
            </el-table-column>
        </el-table>
        <div class="u-f u-ac u-jsb ft_mr">
            <div></div>
            <div>
                <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
                    :current-page="currentPage" :page-sizes="[15, 30, 50, 100]" :page-size="pagesize"
                    layout="total, sizes, prev, pager, next, jumper" :total="count">
                </el-pagination>
            </div>
        </div>

        <el-dialog title="新建" :visible.sync="adddialogVisible" top="50px" width="50%" class="dialogs" append-to-body>
            <el-divider></el-divider>
            <div class="dialog-ibox-content">
                <el-form :model="ruleForm" :rules="problems" ref="ruleForm" label-width="150px"
                    class="demo-ruleForm forms-lines">
                    <div class="problem_box">
                        <el-form-item label="开始日期" style="margin-top:10px" prop="start_time">
                            <el-date-picker v-model="ruleForm.start_time" type="date" size="small" value-format="yyyy-MM-dd" placeholder="选择开始日期">
                            </el-date-picker>
                        </el-form-item>
                          <el-form-item label="结束日期" style="margin-top:10px" prop="end_time">
                            <el-date-picker v-model="ruleForm.end_time" type="date" size="small" value-format="yyyy-MM-dd" placeholder="选择结束日期">
                            </el-date-picker>
                        </el-form-item>
                        <el-form-item label="基础销量" style="margin-top:10px" prop="base_sale">
                            <el-input v-model="ruleForm.base_sale" placeholder="请输入基础销量" size="small"></el-input>
                        </el-form-item>
                        <el-form-item label="总数" style="margin-top:10px" prop="count">
                            <el-input v-model="ruleForm.count" placeholder="请输入总数" size="small"></el-input>
                        </el-form-item>
                        <el-form-item label="金额" style="margin-top:10px" prop="price">
                            <el-input v-model="ruleForm.price" placeholder="请输入金额" size="small"></el-input>
                        </el-form-item>
                        <el-form-item label="积分" style="margin-top:10px" prop="point">
                            <el-input v-model="ruleForm.point" placeholder="请输入积分" size="small"></el-input>
                        </el-form-item>

                    </div>
                </el-form>
            </div>
            <el-divider></el-divider>
            <span slot="footer" class="dialog-footer">
                <el-button @click="submit('ruleForm')" size="small" type="primary" :loading="subloading">确 定
                </el-button>
                <el-button @click="adddialogVisible = false" size="small">取 消</el-button>
            </span>
        </el-dialog>
    </div>
</template>

<script>
    export default {
        data() {
            return {
                proData: [],
                textId: '',
                loading: false,
                subloading: false,
                height: null,
                adddialogVisible: false,
                ruleForm: {
                    start_time:'',
                    end_time:'',
                    base_sale:'',
                    count:'',
                    price:'',
                    point:'',
                    goods_id:'',
                },
                problems: {
                    start_time: [{
                        required: true,
                        message: '请选择开始日期',
                        trigger: 'blur'
                    }, ],
                    end_time: [{
                        required: true,
                        message: '请选择结束日期',
                        trigger: 'blur'
                    }, ],
                    base_sale: [{
                        required: true,
                        message: '请输入基础销量',
                        trigger: 'blur'
                    }, ],
                    count: [{
                        required: true,
                        message: '请输入总数',
                        trigger: 'blur'
                    }, ],
                    price: [{
                        required: true,
                        message: '请输入金额',
                        trigger: 'blur'
                    }, ],
                    point: [{
                        required: true,
                        message: '请输入积分',
                        trigger: 'blur'
                    }, ],
                  

                },
                eid: '',
                proloading: false,

                yhq_options: [],
                mapListed: [],
                currentPage: 1,
                pagesize: 15,
                count: 0
            }
        },
        mounted() {
            this.getHeight()
            // this.getlist()

        },
        methods: {
            getHeight() {
                let that = this
                that.height = window.innerHeight - 310 + 'px'
                window.onresize = () => {
                    that.height = window.innerHeight - 310 + 'px'
                }
            },
            handleAdd() {
                this.clearf()
                this.eid = ''
                this.adddialogVisible = true
            },
            clearf() {
                this.ruleForm = {
                    start_time:'',
                    end_time:'',
                    base_sale:'',
                    count:'',
                    price:'',
                    point:'',
                }
            },
        
            getlist(id) {
                this.proData = []
                this.proloading = true
                axios
                    .post("/admin/wssadmin/seckill/goodsSeckill", {
                        goods_id: id,
                        page: this.currentPage,
                        page_count: this.pagesize
                    }, {
                        token: true
                    })
                    .then(response => {
                        this.proloading = false
                        if (response.data.code == '200') {
                            this.proData = response.data.data.list
                            this.count = response.data.data.count
                        } else {
                            that.$message.error(response.data.msg);
                        }
                    })
                    .catch(error => {})
            },
            handleSizeChange(val) {
                let that = this
                that.pagesize = val;
                that.getlist()
            },
            handleCurrentChange(val) {
                let that = this
                that.currentPage = val;
                that.getlist()
            },
            handleEdit(row, index) {
                this.ruleForm=row
                this.eid = row.id
                this.adddialogVisible = true
            },
            handleDelet(row, index) {
                let that = this
                this.$confirm('此操作将永久删除该问题, 是否继续?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    this.proloading = true
                    axios
                        .post("admin/wssadmin/seckill/del", {
                            id: row.id,
                        }, {
                            token: true
                        })
                        .then(response => {
                            if (response.data.code == '200') {
                                this.$message({
                                    type: 'success',
                                    message: '删除成功!'
                                });
                                that.getlist(this.textId)
                            } else {
                                that.$message.error(response.data.msg);
                            }
                        })
                        .catch(error => {})
                }).catch(() => {
                    this.$message({
                        type: 'info',
                        message: '已取消删除'
                    });
                });
            },
            submit(formName) {
                let that = this
                that.$refs[formName].validate((valid) => {
                    if (valid) {
                        this.ruleForm.goods_id=this.textId
                        let urls = "/admin/wssadmin/seckill/seckill"
                        this.subloading = true
                        axios.post(urls, {
                                ...this.ruleForm,
                            }, {
                                token: true
                            })
                            .then(response => {
                                that.subloading = false
                                if (response.data.code == '200') {
                                    that.adddialogVisible = false
                                    that.getlist(this.textId)
                                } else {
                                    that.$message.error(response.data.msg);
                                }
                            })
                            .catch(error => {
                                that.subloading = false
                            })
                    } else {
                        // this.$alert("信息遗漏未填")
                        return false;
                    }
                });
            },
        },
        watch: {
            'ruleForm.choose_type'(val, old) {
                if (val == 3) {
                    this.ruleForm.options = [{
                        option: "",
                        // option_type: 1,
                        score: '',
                    }]
                }
            }
        }
    }
</script>

<style lang="scss" scoped>
    .add_tits {
        padding: 0 10px;
    }
</style>